<template>
  <div
    v-if="isSpecial"
    class="dh-psy-logo-title"
  >
    <div
      class="dh-psy-logo-title__pre-title"
      v-if="preTitle"
    ><span v-html="preTitle" /></div>
    <h1 class="nrk-sr">{{ stringifiedTitle }}</h1>
    <Logo type="large" />
    <div
      v-if="runningTitle"
      class="dh-psy-logo-title__running-title"
    ><span v-html="runningTitle" /></div>
  </div>
  <h1
    :class="className"
    :aria-label="stringifiedTitle"
    v-else-if="item"
  >
    <span
      v-for="(text, idx) in item"
      v-bind:key="idx"
    >
      <span
        v-if="typeof text === 'string'"
        v-html="text"
      />
      <enhanced-text
        v-else
        :value='text.value'
        :type='text.type'
        :revealed="active"
      ></enhanced-text>
    </span>
  </h1>
  <h1
    :class="className"
    :aria-label="stringifiedTitle"
    v-else
  >
    <span
      v-for="(text, idx) in title"
      v-bind:key="idx"
    >
      <span
        v-if="typeof text === 'string'"
        v-html="text"
      />
      <enhanced-text
        v-else
        :value='text.value'
        :type='text.type'
        :revealed="active"
      ></enhanced-text>
    </span>
  </h1>
</template>

<style lang="postcss">
  .dh-psy-title {
    font-family: NRK Etica Slab;
    font-weight: 100;
    text-align: center;
    font-size: calc(1.75em + 0.2vw);
    text-shadow: 0 1px 5px rgba(21, 22, 23, 0.6), 0 2px 10px rgba(21, 22, 23, 0.207);
    line-height: 1.3;
    width: 90%;
    margin: 20vh auto 20vh;
    margin: calc(20 * var(--dh-vh)) auto calc(20 * var(--dh-vh));

    max-width: 590px;

    @media (min-width: 540px) {
      font-size: calc(1.8em + 0.2vw);
      width: 60%;
    }

    @media (min-width: 800px) {
      font-size: calc(4.2em + 0.1vw);
      width: 80%;
    }

    @media (min-width: 1200px) {
      font-size: calc(3.2em + 0.1vw);
      width: 100%;
    }

    & :global(.dh-psy-cencored) {
      text-shadow: none;
    }
  }

  .dh-psy-logo-title {
    width: 90%;
    max-width: 90%;
    margin: 150px auto;
    @media (min-width: 540px) {
      width: 500px;
      max-width: 90%;
      margin: 150px auto;
    }

    @media (min-width: 800px) {
      width: 500px;
      max-width: 90%;
      margin: 150px auto;
    }

    @media (min-width: 800px) {
      width: 700px;
      max-width: 90%;
      margin: 250px auto;
    }

    & .dh-psy-logo-title__pre-title {
      text-align: center;
      text-transform: uppercase;
      font-size: 0.8em;
      color: #777;
    }

    & .dh-psy-logo-title__running-title {
      text-align: center;
      font-family: 'NRK Etica Slab';
      font-size: 1em;

      @media (min-width: 540px) {
        font-size: 1.2em;
      }

      @media (min-width: 800px) {
        font-size: 1.3em;
      }

      @media (min-width: 1200px) {
      }
    }

    & :global(.dh-psy-logo) {
      width: 100%;
      margin: 30px 0 20px;
      max-width: 700px;
    }
  }
</style>

<script>
import EnhancedText from './components/enhanced-text/index.vue'
import Logo from '../Widgets/Logo.vue'

function reduce(pv, cv) {
  if (typeof cv === 'string') {
    pv += cv
    return pv
  } else if (typeof cv === 'object' && cv.value) {
    pv += cv.value
    return pv
  }
  return pv
}

export default {
  props: ['item', 'active'],
  data() {
    const modifiers = this.$root.$data.props.doc['title-modifier']
    const classNames = modifiers
      ? modifiers
          .split(' ')
          .map(modifier => `dh-psy-title--${modifier}`)
          .join(' ')
      : ''

    const preTitle = this.$root.$data.props.doc['pre-title']
    const runningTitle = this.$root.$data.props.doc['running-title']

    return {
      isSpecial: preTitle || runningTitle,
      title: this.$root.$data.props.doc.title,
      preTitle,
      runningTitle,
      className: `dh-psy-title ${classNames}`
    }
  },
  computed: {
    stringifiedTitle() {
      return this.item
        ? this.item.reduce(reduce, '').replace(/<br>/g, ' ')
        : this.title.reduce(reduce, '').replace(/<br>/g, ' ')
    }
  },
  components: {
    EnhancedText,
    Logo
  }
}
</script>
